export default "__VITE_ASSET__b7fae3ca__"